import axios from 'axios';
import queryString from 'query-string';

declare var mapboxgl: any;
declare var siteInfo: any;

const onDisplayMap = (map: any): void => {

}

const onDisplayListing = (map: any): void => {

}

const createMap = (mapElement: HTMLElement, options: any): any => {
  mapboxgl.accessToken = options.key;
  const map = new mapboxgl.Map({
    container: mapElement.id,
    style: 'mapbox://styles/mapbox/streets-v11', // style URL
    center: [-5.109225, 54.445471],
    zoom: 4
  });

  map.addControl(new mapboxgl.NavigationControl());

  map.on('load', () => {
    map.resize()
  })

  return map;
}

const updateMarkers = (mapInstance: any, options: any, markers: any): void => {
  const properties = mapInstance.querySourceFeatures('properties');
  const keepMarkers: any[] = [];
  const popupOpened: any = {};

  for (let i = 0; i < properties.length; i++) {
    const coords = properties[i].geometry.coordinates;
    const props = properties[i].properties;
    const featureID = properties[i].id;

    const clusterID = props.cluster_id || null;

    if (props.cluster && markers.has('cluster_' + clusterID)) {
      //Cluster marker is already on screen
      keepMarkers.push('cluster_' + clusterID);

    } else if (props.cluster) {
      //This feature is clustered, create an icon for it and use props.point_count for its count

      let el = undefined;
      if (options.clusterOptions.url) {
        el = document.createElement('div');
        const width = options.clusterOptions.width || 60;
        const height = options.clusterOptions.height || 60;

        el.classList.add('mapCluster');
        el.style.backgroundImage = `url(${options.clusterOptions.url})`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;
        el.style.textAlign = 'center';
        el.style.color = options.clusterOptions.textColor || 'white';
        el.style.fontSize = options.clusterOptions.textSize + 'px' || '15px';
        el.style.backgroundSize = '100%';
        el.innerHTML = `<div class="mapCluster__inner">${props.point_count}</div>`;
      }
      const marker = new mapboxgl.Marker(el).setLngLat(coords);
      marker.addTo(mapInstance);
      keepMarkers.push('cluster_' + featureID);
      markers.set('cluster_' + clusterID, el);
    } else if (markers.has(featureID)) {
      //Feature marker is already on screen
      keepMarkers.push(featureID);
    } else {
      //Feature is not clustered and has not been created, create an icon for it
      const popup = new mapboxgl.Popup()
        .setHTML('Loading...');
      popup.on('open', () => {
        if (popupOpened[properties[i].id])
          return

        const siteUrl = typeof siteInfo.url !== 'undefined'
          ? siteInfo.url
          : '';
        const searchParams = queryString.parse(location.search);
        if (typeof (window as any).searched === 'object') {
          const searchedKeys = Object.keys((window as any).searched);
          for (let i = 0; i < searchedKeys.length; i++) {
            searchParams[searchedKeys[i]] = (window as any).searched[searchedKeys[i]];
          }
        }
        searchParams['id'] = properties[i].id;
        axios.get(`${siteUrl}/wp-json/accommodation/map/property/description?${queryString.stringify(searchParams)}`)
          .then((response) => {
            popupOpened[properties[i].id] = true;
            popup.setHTML(response.data);

            popup.fire('close');
            popup.fire('open');
          });
      })
      let el = undefined;
      if (options.marker.url) {
        el = document.createElement('div');
        const width = options.marker.width || 71;
        const height = options.marker.height || 81;

        el.classList.add('marker');
        el.style.backgroundImage = `url(${options.marker.url})`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;
        el.style.backgroundSize = '100%';
      }
      const marker = new mapboxgl.Marker(el).setLngLat(coords).setPopup(popup);
      marker.addTo(mapInstance);
      keepMarkers.push(featureID);
      markers.set(featureID, el);
    }


    //Let's clean-up any old markers. Loop through all markers
    markers.forEach((value: any, key: any, map: any) => {
      //If marker exists but is not in the keep array
      if (keepMarkers.indexOf(key) === -1) {
        //Remove it from the page
        value.remove();
        //Remove it from markers map
        map.delete(key);
      }
    });
  }
}

const placePropertyPins = (mapInstance: any, options: any, properties: any[], createMarker: (property: any) => any): any[] => {
  const markers: any[] = [];

  const points = {
    type: 'FeatureCollection',
    features: properties.map((property) => {
      return {
        type: 'Feature',
        id: property.property_code,
        properties: {
          id: property.property_code,
          description: property.description,
        },
        geometry: {
          type: 'Point',
          coordinates: [
            property.longitude,
            property.latitude,
            0
          ]
        }
      }
    })
  };

  const markersMap = new Map();
  mapInstance.on('data', (e: any) => {
    if (!e.isSourceLoaded) return;
    // Throttle these
    mapInstance.on('moveend', () => updateMarkers(mapInstance, options, markersMap));
    updateMarkers(mapInstance, options, markersMap);
  });

  mapInstance.addSource('properties', {
    type: 'geojson',
    data: points,
    cluster: options.cluster,
    clusterMaxZoom: 6,
    clusterRadius: 25,
  });
  mapInstance.addLayer({
    id: 'clusters',
    type: 'circle',
    source: 'properties',
    filter: ['has', 'point_count'],
    paint: {
      'circle-radius': 0
    }
  });
  return markers;
}

const removeAllMarkers = (mapInstance: any): void => {
  mapInstance.removeLayer('clusters');
  mapInstance.removeSource('properties');
}

const addMarker = (mapInstance: any, options: any, property: any, position: any): any => {
  const popup = new mapboxgl.Popup()
    .setHTML(property.description);

  let el = undefined;
  if (options.marker.url) {
    el = document.createElement('div');
    const width = options.marker.width || 71;
    const height = options.marker.height || 81;

    el.classList.add('marker');
    el.style.backgroundImage = `url(${options.marker.url})`;
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    el.style.backgroundSize = '100%';
  }

  const marker = new mapboxgl.Marker(el)
    .setLngLat([position.lng, position.lat])
    .setPopup(popup);

  return { marker, el };
}

const enableClustering = (mapInstance: any, options: any, container: HTMLElement, markers: any[]): void => {
}

export default {
  onDisplayMap,
  onDisplayListing,
  createMap,
  placePropertyPins,
  addMarker,
  enableClustering,
  removeAllMarkers,
}
